/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-23 15:00:00
 *
 *******************************************************/
//@flow

import React from 'react';
import { Collapsible } from '@shopify/polaris';
import IconUncheck from 'src/assets/images/quick-start-guide/icon.uncheck.svg';
import IconChecked from 'src/assets/images/quick-start-guide/icon.checked.svg';

export function GuideV2ItemStep({
  children,
  isChecked,
  isHideCheckIcon,
  title,
  titleComponent,
  secondarySection,
  isOpen,
  onOpen = () => {},
  keyGuide,
  keyStep,
  index,
  firstStatusOpen
}) {
  const checkStatus = isChecked ? (
    <img className="status" src={IconChecked} alt="IconChecked" width={20} height={20} />
  ) : (
    <img className="status" src={IconUncheck} alt="IconUncheck" width={20} height={20} />
  );
  return (
    <div className="GuideV2ItemStep">
      <div
        className={`GuideV2ItemStep__Activator ${isHideCheckIcon && 'title-preview'}`}
        onClick={() => {
          onOpen(keyGuide, index, firstStatusOpen || isOpen);

          // This trick when expand child, the parent not expand => child was hided part
          setTimeout(() => {
            const guide = document.getElementById(`basic-collapsible-${keyGuide}`);
            if (guide && guide.style) guide.style.maxHeight = 'none';
          }, 100);
        }}>
        {isHideCheckIcon ? <div style={{ width: '20px' }} /> : checkStatus}
        <div className="title">{titleComponent || title}</div>
      </div>
      <Collapsible
        open={firstStatusOpen || isOpen}
        id={`basic-collapsible-${keyStep}`}
        transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}>
        <div className="GuideV2ItemStep__Container">
          <div className="container">
            <div>{children}</div>
          </div>
        </div>
        {secondarySection && (
          <div className="GuideV2ItemStep__Container_Secondary">{secondarySection}</div>
        )}
      </Collapsible>
    </div>
  );
}
